import React from 'react';

import BrokerWhichPolicyJSON from '@zego/content/broker-fleet-policy-section.json';

import WhichPolicySection from '@zego/components/organisms/WhichPolicySection';

export default function BrokerWhichPolicySection(): JSX.Element {
  return <WhichPolicySection {...BrokerWhichPolicyJSON} />;
}
